import { createAction, props } from '@ngrx/store'
import { IntegrationAuthData, ThirdPartyIntegrationIdentifies } from './model'

export const LoadAuthorizedIntegration = createAction(
  '[Integration] Load Authorized Integration',
  props<{ integration: ThirdPartyIntegrationIdentifies }>()
)
export const LoadAuthorizedIntegrationComplete = createAction(
  '[Integration] Load Authorized Integration Complete',
  props<{ data?: IntegrationAuthData | any; integration: ThirdPartyIntegrationIdentifies }>()
)

export const LoadAuthorizeIntegrationConfig = createAction(
  '[Integration] Load Authorized Integration Config',
  props<{ integration: ThirdPartyIntegrationIdentifies }>()
)
export const LoadAuthorizeIntegrationConfigComplete = createAction(
  '[Integration] Load Authorized Integration Config Complete',
  props<{ data: IntegrationAuthData; integration: ThirdPartyIntegrationIdentifies }>()
)

export const UnauthorizeIntegration = createAction(
  '[Integration] Unauthorized Integration',
  props<{ integration: ThirdPartyIntegrationIdentifies }>()
)
export const UnauthorizeIntegrationComplete = createAction(
  '[Integration] Unauthorized Integration Complete',
  props<{ integration: ThirdPartyIntegrationIdentifies }>()
)

export const ConnectWheelhouse = createAction('[Integration] Connect Wheelhouse', props<{ apiKey: string }>())
export const ConnectWheelhouseComplete = createAction('[Integration] Connect Wheelhouse Complete', props<{}>())

export const DisconnectWheelhouse = createAction('[Integration] Disconnect Wheelhouse', props<{}>())
export const DisconnectWheelhouseComplete = createAction('[Integration] Disconnect Wheelhouse Complete', props<{}>())

export const ConnectChekin = createAction('[Integration] Connect Chekin', props<{ accountType: string }>())
export const ConnectChekinComplete = createAction('[Integration] Connect Chekin Complete', props<{}>())

export const DisconnectChekin = createAction('[Integration] Disconnect Chekin', props<{}>())
export const DisconnectChekinComplete = createAction('[Integration] Disconnect Chekin Complete', props<{}>())

export const DisconnectQuickBooks = createAction('[Integration] Disconnect QuickBooks')
export const DisconnectQuickBooksComplete = createAction('[Integration] Disconnect QuickBooks Complete', props<{}>())

export const ConnectHolded = createAction('[Integration] Connect Holded', props<{ apiKey: string }>())
export const ConnectHoldedComplete = createAction('[Integration] Connect Holded Complete', props<{}>())

export const DisconnectHolded = createAction('[Integration] Disconnect Holded', props<{}>())
export const DisconnectHoldedComplete = createAction('[Integration] Disconnect Holded Complete', props<{}>())
